import React from 'react';

interface FormHeaderProps {
  title: string;
  subtitle: string;
  compact?: boolean;
  align?: 'center' | 'left';
  headingLevel?: 'h1' | 'h2' | 'h3';
  titleClassName?: string;
}

const FormHeader: React.FC<FormHeaderProps> = ({
  title,
  subtitle,
  compact = false,
  align = 'center',
  headingLevel = 'h1',
  titleClassName,
}) => {
  const HeadingTag = headingLevel;
  const headingClassName =
    titleClassName ??
    `text-lg md:text-xl font-bold text-white mb-2 ${align === 'left' ? 'text-left' : ''}`;

  return (
    <div
      className={`${align === 'left' ? 'text-left' : 'text-center'} ${compact ? 'mb-4' : 'mb-8'}`}
    >
      <HeadingTag className={headingClassName}>{title}</HeadingTag>
      {subtitle ? <p className="text-gray-300 text-lg">{subtitle}</p> : null}
    </div>
  );
};

export default FormHeader;
